import { render, staticRenderFns } from "./LoyaltyJoinUs.vue?vue&type=template&id=a6c6fd64&scoped=true&"
import script from "./LoyaltyJoinUs.vue?vue&type=script&lang=js&"
export * from "./LoyaltyJoinUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c6fd64",
  null
  
)

export default component.exports